import { Util } from "@xt/xtbase";
import { getCfdDepositPath } from "@/components/Pages/Cfd/_cmpt/depositLinks";
import { HYPERPAY_PAY_CURRENCIES, normalizeHyperpayPayCurrency } from "@/utils/spikexCard";

const { getUrl } = Util;

/** loginStatus 初始为 0，需等待鉴权完成后再做跳转判断 */
export function isLoginStatusPending(loginStatus) {
  return loginStatus === 0 || loginStatus == null;
}

/** 站外 / user-center / Vue SPA（/accounts、/wallet 等） */
export function navigateExternal(path) {
  if (typeof window === "undefined") return;
  window.location.assign(getUrl(path));
}

export function navigateAccountsLogin() {
  if (typeof window === "undefined") return;
  navigateExternal(`/accounts/login?backurl=${encodeURIComponent(window.location.href)}`);
}

/** Next 站内 spikex-card 路由（locale 由 Next router 处理） */
export function pushSpikexCardRoute(router, pathname, query) {
  if (!router?.push) return;
  if (query && Object.keys(query).length > 0) {
    router.push({ pathname, query });
    return;
  }
  router.push(pathname);
}

/** 替换当前历史记录，避免返回再次进入上一页（如申请提交完成后回卡片页） */
export function replaceSpikexCardRoute(router, pathname, query) {
  if (!router?.replace) return;
  if (query && Object.keys(query).length > 0) {
    router.replace({ pathname, query });
    return;
  }
  router.replace(pathname);
}

/** 开卡余额不足弹窗：跳转 USDT / BRL 充值（PC / 移动端路径与 CFD 一致） */
export function navigateSpikexCardDeposit(currency, { isSpikexPc = false } = {}) {
  if (typeof window === "undefined") return;
  const normalized = normalizeHyperpayPayCurrency(currency);
  const isFiat = normalized === HYPERPAY_PAY_CURRENCIES.BRL;
  const path = getCfdDepositPath({
    isFiat,
    quoteCurrency: normalized,
    spikexPc: isSpikexPc,
  });
  window.location.assign(getUrl(path));
}
